import React from "react";
import usePixModalStyles from "../PixPaymentModal.styles";
import { PixSummaryHeaderProps } from "../types";

const currency = (value: number) =>
  value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

/**
 * Cabeçalho consolidado do modal de Pix (SP-1294 / D5):
 * identificação da ordem, valor total e contador "X de Y pagos".
 */
const PixSummaryHeader: React.FC<PixSummaryHeaderProps> = ({
  orderNumber,
  total,
  paidCount,
  count,
}) => {
  const classes = usePixModalStyles();
  const allPaid = count > 0 && paidCount === count;

  return (
    <div className={classes.summaryHeader}>
      <div>
        <h4 className={classes.summaryOrder}>Pedido #{orderNumber}</h4>
        <div className={classes.summaryTotal}>
          Total{" "}
          <span className={classes.summaryTotalValue}>{currency(total)}</span>
        </div>
      </div>

      <span
        className={`${classes.summaryCounter} ${
          allPaid ? classes.summaryCounterAllPaid : ""
        }`}
      >
        {paidCount} de {count} pagos
      </span>
    </div>
  );
};

export default PixSummaryHeader;
